<template>
  <div>
    <div
      class="h-40 flex items-center justify-between px-15"
      :style="flag ? '' : { borderBottom: '1px solid #CCD3DF' }"
    >
      <span class="text-15 text-default font-600">{{ title }}</span>
      <slot name="right" v-if="$slots.right"></slot>
      <span class="text-theme flex items-center text-14" @click="onSwitch" v-if="showSwitch">
        {{ flag ? " 收起" : "展开" }}
        <van-icon :name="flag ? 'arrow-down' : 'arrow-up'" style="margin-left:5px" size="12" />
      </span>
    </div>
    <slot></slot>
  </div>
</template>
<script setup>
import { ref } from "vue";
// import task_hidden from "@/assets/maintenance/task_hidden.png";
// import task_show from "@/assets/maintenance/task_show.png";
const props = defineProps({
  title: String,
  type: { default: true }, //当前展开OR收起状态
  showSwitch: { default: false }
});

const emit = defineEmits(["switch"]);

const flag = ref(props.type);

const onSwitch = () => {
  flag.value = !flag.value;
  emit("switch", flag.value);
};
</script>
